// --------------------------
// MAIN COMPONENT
// --------------------------
const DashboardCards = (props) => {
  // --------------------------------
  // DESTRUCTURED PROP's VARIABLES
  // --------------------------------
  const { item, itemValue, itemIcon, isCurrency } = props;

  // --------------------------
  // LOCAL VARIABLES
  // --------------------------
  const updatedItem = item.toUpperCase().replace(" ", "_");
  const value = itemValue?.[updatedItem] ?? 0;

  const integerPart = Math.floor(value).toLocaleString();
  const decimalPart = (value % 1).toFixed(2).split(".")[1];

  // --------------------------
  // JSX RETURN
  // --------------------------
  return (
    <div className="card dashboardCard bgi-no-repeat card-stretch gutter-b border-2 rounded-lg p-5">
      <div className="cardWrap">
        <div className="cardWrap-col">
          <p className="text-dark-grey-custom mb-2">{item}</p>
          <div className="font-weight-bold font-size-sm">
            <span className="font-size-h2 mr-2 customPrice">
              {isCurrency && process.env.REACT_APP_DEFAULT_CURRENCY}
              {integerPart}
              {decimalPart != 0 && <small>.{decimalPart}</small>}
            </span>
          </div>
        </div>
        <div className="cardWrap-col">
          <img src={itemIcon} alt="card icon" />
        </div>
      </div>
    </div>
  );
};

export default DashboardCards;
